import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MacCommandFilledSvg from "@ant-design/icons-svg/es/asn/MacCommandFilled";
import AntdIcon from "../components/AntdIcon";
var MacCommandFilled = function MacCommandFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MacCommandFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MacCommandFilled.displayName = 'MacCommandFilled';
}
export default /*#__PURE__*/React.forwardRef(MacCommandFilled);